import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Avatar,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { ExpandMore, ExpandLess, ArrowBack } from "@mui/icons-material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import PreviewIcon from "@mui/icons-material/Preview";
import { useMediaQuery } from "@mui/material";

import Accountmenu from "../menu/Accountmenu";
import logo from "../../assets/images/logotalent.png";
import logoMan from "../../assets/images/logoman.png";
import { useLocation, useNavigate } from "react-router-dom";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { s3baseUri } from "../../config/config";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import RecordNotFound2 from "../recordNotFound/SataNitFound";
import { is_small_medium_screen, sourceAccessMap } from "../../utils/Constant";
import { Icon } from "@iconify/react/dist/iconify.js";
import UpgradeModal from "../popUp/UpgradeModal";
import PostJobHeader from "../../pages/post/PostJobHeader";
import { bell_icon, burger_icon, portal_logo, search_icon } from "../../assets";
import CustomModalLayout from "../modal/CustomModalLayout";
import NotificationPanel from "../NotificationPanel/NotificationPanel";

const Header = ({ setDrawerOpen }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [profileImage, setProfileImage] = useState();
  const { profileNewImage, breadCrumb, userInfo, findId } = useIds();

  const [isHitFirst, setIsHitFirst] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const [detailData, setDetailData] = useState(null);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [open, setOpen] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const load_more_path = "api/jobs/list?page=0&limit=50";

  const openAccount = Boolean(anchorEl);
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const firstSegment = location.pathname.split("/")[1];

  const handleOpen = () => {
    if (
      (userInfo?.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo?.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    // setOpen(true);
    // setEditMode(false);

    navigate("/post-new-job");
  };

  const handleOpenEditJob = (job) => {
    setEditMode(true);
    setSelectedJob(job);
    setOpen(true);
  };

  const handleNavigate = () => {
    navigate("/favourite-jobs");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseJobPanel = () => {
    setOpen(false);
  };

  const handleHome = () => {
    navigate("/home");
  };

  const smartBack = () => {
    let matched = null;
    const filterArray = breadCrumb.filter(
      (item) => item.path !== "" && pathname !== item.path
    );
    matched = filterArray.length ? filterArray.at(-1) : null;

    if (matched && matched?.path !== pathname) {
      navigate(matched.path);
    } else {
      navigate("/home");
    }
  };

  const handleSummarizeClick = () => {
    if (userInfo?.role === "client" || userInfo.isCompanyProfile) {
      navigate(`/my-job-posts`);
    }
  };
  const ismobile = useMediaQuery("(max-width:600px)");

  const showBackButton = pathname !== "/dashboard" && pathname !== "/home";
  const iconColor = "var(--portal-primary-color)";

  useEffect(() => {
    const timer = setTimeout(() => {
      setProfileImage(profileNewImage);
    }, 1000);
    return () => clearTimeout(timer);
  }, [profileNewImage]);

  return (
    <>
      <UpgradeModal
        open={openUpgradeModal}
        handleClose={() => setOpenUpgradeModal(false)}
      />

      <CustomModalLayout
        open={open}
        onClose={handleCloseJobPanel}
        title={editMode ? "Update Job" : "Post Job"}
        width="850px"
        componentToPass={
          <PostJobHeader
            refreshlist={() => {}}
            loadMorePath={load_more_path}
            searchTerm={searchTerm}
            loadingstate={loading}
            id={findId || localStorage.getItem("source_id")}
            open={open}
            handleClose={handleCloseJobPanel}
            editMode={editMode}
            jobData={selectedJob}
            sourceId={sourceId}
          />
        }
      />

      <AppBar className="header-appbar header-wrapper" position="fixed">
        <div
          sx={{ display: "flex", justifyContent: "space-between" }}
          className="container header-inner"
        >
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
            className="logo-box-wrapper"
          >
            {showBackButton && (
              <Tooltip title="Go Back">
                <span>
                  <IconButton
                    className="p-0"
                    onClick={smartBack}
                    aria-label="Go Back"
                    type="button"
                    size="medium"
                    sx={{
                      color: iconColor,
                      animation: "bounceLeftRight 1s infinite",
                      "&:hover": {
                        animation: "none",
                        backgroundColor: "rgba(118, 118, 149, 0.1)",
                      },
                    }}
                  >
                    <ArrowBack />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            <div className="show-on-lg">
              <Icon
                onClick={() => {
                  setDrawerOpen(true);
                }}
                className="sidebar-icon"
                icon="icon-park:hamburger-button"
                width="30"
              />
            </div>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minHeight: { xs: "auto", sm: 0 },
              }}
            >
              <img
                onClick={handleHome}
                src={portal_logo}
                alt="Logo"
                style={{ width: "150px", cursor: "pointer" }}
              />
            </Box>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            {Array.isArray(userInfo?.source) &&
              userInfo?.role === "candidate" &&
              userInfo?.source.length > 0 &&
              !userInfo?.isCompanyProfile && (
                <Tooltip title="View Favorite Jobs">
                  <IconButton
                    onClick={handleNavigate}
                    size="small"
                    sx={{ p: 0.5, color: "var(--portal-primary-color)" }}
                  >
                    <BookmarkIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

            {((userInfo?.role === "client" && !userInfo?.isCompanyProfile) ||
              (userInfo?.isCompanyProfile &&
                userInfo?.company_access?.job?.add)) && (
              <div
                className="header-item hover-primary hide-on-sm"
                onClick={handleOpen}
              >
                <span>Post Job</span>
              </div>
            )}
            {(userInfo?.role === "client" || userInfo?.isCompanyProfile) && (
              <div
                className="header-item hover-primary hide-on-sm"
                onClick={handleSummarizeClick}
              >
                <span>My Jobs</span>
              </div>
            )}

            <div className="header-item-icon">
              <div>
                {/* <img className="hover-primary" src={search_icon} alt="" /> */}
              </div>
              <NotificationPanel />
            </div>
            <IconButton
              onClick={handleClick}
              sx={{
                color: "var(--portal-primary-color)",
                position: "relative",
                p: 0,
                marginLeft: "6px",
              }}
            >
              <Box sx={{ position: "relative", display: "inline-block" }}>
                <Avatar
                  src={
                    s3baseUri +
                    userInfo?.company_profile?.profile_image?.thumbnail_1
                  }
                  sx={{ width: 40, height: 40 }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: -8,
                    bgcolor:
                      (userInfo?.role === "client" &&
                        userInfo?.has_pending_requests &&
                        !userInfo?.isCompanyProfile) ||
                      (userInfo?.user_invitaion_status &&
                        !userInfo?.isCompanyProfile) ||
                      ((userInfo?.direct_contact_check ||
                        userInfo?.has_pending_affiliation_request) &&
                        !userInfo?.isCompanyProfile) ||
                      (userInfo?.isCompanyProfile &&
                        userInfo?.company_access?.manage_profile
                          ?.company_profile &&
                        (userInfo?.direct_contact_check ||
                          userInfo?.has_pending_affiliation_request))
                        ? "red"
                        : "#fff",
                    color:
                      (userInfo?.role === "client" &&
                        userInfo?.has_pending_requests &&
                        !userInfo?.isCompanyProfile) ||
                      (userInfo?.user_invitaion_status &&
                        !userInfo?.isCompanyProfile) ||
                      ((userInfo?.direct_contact_check ||
                        userInfo?.has_pending_affiliation_request) &&
                        !userInfo?.isCompanyProfile) ||
                      (userInfo?.isCompanyProfile &&
                        userInfo?.company_access?.manage_profile
                          ?.company_profile &&
                        (userInfo?.direct_contact_check ||
                          userInfo?.has_pending_affiliation_request))
                        ? "#fff"
                        : "",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {openAccount ? (
                    <ExpandLess fontSize="small" />
                  ) : (
                    <ExpandMore fontSize="small" />
                  )}
                </Box>
              </Box>
            </IconButton>
          </Box>

          <Accountmenu
            anchorEl={anchorEl}
            open={openAccount}
            handleClose={handleClose}
          />
        </div>
      </AppBar>
    </>
  );
};

export default Header;
